import { FormControl as ChakraFormControl, type FormControlProps as ChakraFormControlProps } from "@chakra-ui/react";
import { type FC } from "react";
import { formControlTestId } from "./const";
import { FormControlContext } from "./context";

export interface FormControlProps extends ChakraFormControlProps {
  isDirty?: boolean;
}

export const FormControl: FC<FormControlProps> = ({ isInvalid, isRequired, isDirty, ...props }: FormControlProps) => {
  return (
    <FormControlContext.Provider
      value={{
        isInvalid,
        isRequired,
        isDirty,
      }}
    >
      <ChakraFormControl
        isRequired={isRequired}
        isInvalid={isInvalid && isDirty === true}
        data-testid={formControlTestId}
        {...props}
      />
    </FormControlContext.Provider>
  );
};
